import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, Space, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { editLegalCustomer, editPhysicalCustomer, getCustomer } from '../../services/customerServices';
import LegalCustomerForm from '../../forms/LegalCustomerForm';
import PhysicalCustomerForm from '../../forms/PhysicalCustomerForm';
import { getLoginFormOptions } from '../../../../services/login/Login.api';
import formSetDynamicErrors from '../../../../utils/functions/formSetDynamicErrors';

const forms = {
  legal: LegalCustomerForm,
  physical: PhysicalCustomerForm,
  undefined: () => <Spin><div className="h-[500px]" /></Spin>,
};

function EditCustomer() {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [necessaryData, setNecessaryData] = useState({
    type: undefined,
    customer_id: null,
  });
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState(undefined);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCustomer = async () => {
      const res = await getCustomer(id);
      if (res?.country_phone_code) {
        res.country_phone_code = Number(res.country_phone_code);
      }
      setNecessaryData({
        type: res.type,
        customer_id: res.customer_id,
      });
      form.setFieldsValue(res);
    };

    const fetchOptions = async () => {
      const res = await getLoginFormOptions();
      setOptions(res.data);
    };
    const fetchData = async () => {
      setLoading(true);
      await Promise.all([fetchCustomer(), fetchOptions()]);
      setLoading(false);
    };
    fetchData();
  }, []);

  const CustomerForm = forms?.[necessaryData.type];

  const onFinish = async (values) => {
    try {
      if (necessaryData.type === 'legal') {
        await editLegalCustomer(id, {
          ...values,
          id: necessaryData.customer_id,
        });
      } else {
        await editPhysicalCustomer(id, {
          ...values,
          id: necessaryData.customer_id,
        });
      }
      navigate('/admin/customers');
    } catch (e) {
      formSetDynamicErrors({ form, e });
    }
  };

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <ArrowLeftOutlined style={{ fontSize: '20px' }} onClick={() => navigate('/admin/customers')} />
      <CustomerForm form={form} options={options} loading={loading} onFinish={onFinish} />
    </Space>
  );
}

export default EditCustomer;
